import { useProgramYearStore } from '@/stores/programYear';

import { useProgramYears } from './useProgramYears';

/**
 * 워크스페이스 기준 연도 단일 읽기 지점(specs/032 FR-013) — 연도 기반 메뉴는 이 훅만 읽는다.
 *
 * - `requestYear`: API 로 보낼 연도. 명시 선택이 없으면 `undefined`(서버 기본 연도) — 쿼리 키에도 넣어 연도 전환 시
 *   이전 연도 응답이 섞이지 않게 한다.
 * - `displayYear`: 헤더 표시 연도(명시 선택 ?? 목록 기본 연도). 각 화면의 "YYYY년 기준"은 응답 `targetYear` 를 쓴다.
 */
export function useActiveYear() {
  const explicitYear = useProgramYearStore((s) => s.explicitYear);
  const { data } = useProgramYears();
  return {
    requestYear: explicitYear ?? undefined,
    displayYear: explicitYear ?? data?.defaultYear ?? null,
    isExplicit: explicitYear !== null,
  };
}
